"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All enterprise related data
var CustomerInfo = {
  // General -----------------------------------------------------------------------------------------
  welcome: {
    nl: "Welkom",
    fr: "Bienvenue",
    en: "Welcome",
    de: "Willkommen"
  },
  search_and_select: {
    nl: "Zoek en selecteer jouw vestiging",
    fr: "Cherchez et sélectionnez votre établissement",
    en: "Search and select your establishment",
    de: "Suchen und wählen Sie Ihren Standort aus"
  },
  dear: {
    nl: "Beste",
    fr: "Cher",
    en: "Dear",
    de: "Sehr geehrte/r"
  },
  ci_yes: {
    nl: "Ja",
    fr: "Oui",
    en: "Yes",
    de: "Ja"
  },
  ci_no: {
    nl: "Nee",
    fr: "Non",
    en: "No",
    de: "Nein"
  },
  next: {
    nl: "Volgende",
    fr: "Suivant",
    en: "Next",
    de: "Weiter"
  },
  previous: {
    nl: "Vorige",
    fr: "Précédent",
    en: "Previous",
    de: "Zurück"
  },
  ci_close: {
    nl: "Afsluiten",
    fr: "Fermer",
    en: "Close",
    de: "Schließen"
  },
  ready_to_collaborate: {
    nl: "Klaar om samen te werken aan jouw",
    fr: "Vous êtes prêt à colaborer ensemble à votre",
    en: "Ready to collaborate on your",
    de: "Bereit, an Ihrem"
  },
  local_online_visibility: {
    nl: "lokale online visibiliteit?",
    fr: "visibilité locale en ligne ?",
    en: "local online visibility?",
    de: "lokalen Online-Sichtbarkeit?"
  },
  // Login -----------------------------------------------------------------------------------------
  together_we_work: {
    nl: 'Samen werken we aan een “STERK” verhaal ',
    fr: 'Ensemble, nous travaillons sur une histoire "FORTE"',
    en: 'Together we work on a "STRONG" story ',
    de: 'Gemeinsam arbeiten wir an einer "STARKEN" Geschichte'
  },
  discover_the_added_value: {
    nl: "Ontdek de meerwaarde voor jouw onderneming op:",
    fr: "Découvrez la valeur ajoutée pour votre entreprise sur :",
    en: "Discover the added value for your business at:",
    de: "Entdecken Sie den Mehrwert für Ihr Unternehmen unter:"
  },
  visit_our_site: {
    nl: "Bezoek website",
    fr: "Visitez notre site",
    en: "Visit our site",
    de: "Besuchen Sie unsere Website"
  },
  discover_more: {
    nl: "Ontdek meer",
    fr: "Découvrir plus",
    en: "Discover more ",
    de: "Erfahren Sie mehr"
  },
  ci_address: {
    nl: "Adres",
    fr: "Adresse",
    en: "Address",
    de: "Adresse"
  },
  is_required_by_law: {
    nl: "(is wettelijk verplicht)",
    fr: "(requise par la loi)",
    en: "(is required by law)",
    de: "(ist gesetzlich vorgeschrieben)"
  },
  tel_mob: {
    nl: "Telefoon of mobiel",
    fr: "Téléphone ou mobile",
    en: "Telephone or mobile",
    de: "Telefon oder Handy"
  },
  number_required_by_law: {
    nl: "(1 nr. is wettelijk verplicht)",
    fr: "(1 est requis par la loi)",
    en: "(1 is required by law) ",
    de: "(1 ist gesetzlich vorgeschrieben)"
  },
  not_Required: {
    nl: "(niet verplicht)",
    fr: "(non requis)",
    en: "(not required)",
    de: "(nicht erforderlich)"
  },
  ci_email_login: {
    nl: "E-mail adres",
    fr: "Adresse e-mail",
    en: "E-mail address",
    de: "E-Mail-Adresse"
  },
  legally_required: {
    nl: "(is wettelijk verplicht)",
    fr: "(légalement obligatoire)",
    en: "(legally required)",
    de: "(gesetzlich vorgeschrieben)"
  },
  ci_main_activity: {
    nl: "Je hoofdactiviteit",
    fr: "Votre activité principale",
    en: "Your main activity",
    de: "Ihre Haupttätigkeit"
  },
  in_cbe: {
    nl: "(in KBO):",
    fr: "(en BCE) :",
    en: "(in CBE):",
    de: "(im CBE):"
  },
  ci_customized_activity: {
    nl: "Je aangepaste activiteit via onze diensten",
    fr: "Votre activité sur mesure grâce à nos services",
    en: "Your customized activity through our services",
    de: "Ihre maßgeschneiderte Aktivität über unsere Dienste"
  },
  sign_up_and_fill_in: {
    nl: "Meld je aan en vul eventuele extra nuttige info aan zodat jouw doelgroep je nog beter kan vinden! Je verdient hiermee € 100!",
    fr: "Inscrivez-vous et remplissez toute information supplémentaire utile pour que votre groupe cible puisse encore mieux vous trouver ! Vous gagnez 100 € avec ça !",
    en: "Sign up and fill in any additional useful information so that your target group can find you even better! You earn € 100 with this!",
    de: "Melden Sie sich an und füllen Sie alle zusätzlichen nützlichen Informationen aus, damit Ihre Zielgruppe Sie noch besser finden kann! Sie verdienen damit € 100!"
  },
  here_you_can_log_in_with: {
    nl: "Hier kan je aanmelden met jouw persoonlijk aangemaakt account.",
    fr: "Ici, vous pouvez vous connecter avec votre compte personnel.",
    en: "Here you can log in with your personally created account.",
    de: "Hier können Sie sich mit Ihrem persönlich erstellten Konto anmelden."
  },
  register_with_personal_otp: {
    nl: "Registreer hier met jouw persoonlijk OTP",
    fr: "Enregistrez-vous ici avec votre OTP personnel",
    en: "Register here with your personal OTP",
    de: "Registrieren Sie sich hier mit Ihrem persönlichen OTP"
  },
  your_enterprise_number: {
    nl: "Jouw ondernemingsnummer",
    fr: "Votre numéro d'entreprise",
    en: "Your enterprise number",
    de: "Ihre Unternehmensnummer"
  },
  your_establishment_number: {
    nl: "Jouw vestigingsnummer",
    fr: "Votre numéro d'etablissement",
    en: "Your establishment number",
    de: "Ihre Betriebsnummer"
  },
  otp: {
    nl: "One Time Password",
    fr: "Mot de passe à usage unique",
    en: "One Time Password",
    de: "Einmaliges Passwort"
  },
  dont_have_otp_yet: {
    nl: "Ik heb nog geen OTP",
    fr: "Je n'ai pas encore d'OTP ",
    en: "I don't have an OTP yet",
    de: "Ich habe noch kein OTP"
  },
  password: {
    nl: "Wachtwoord",
    fr: "Mot de passe",
    en: "Password",
    de: "Passwort"
  },
  forgot_password: {
    nl: "Wachtwoord vergeten?",
    fr: "Mot de passe oublié ?",
    en: "Forgot password?",
    de: "Passwort vergessen?"
  },
  reset_password: {
    nl: "Wachtwoord resetten",
    fr: "Reset mot de passe",
    en: "Reset password",
    de: "Passwort zurücksetzen"
  },
  ok_ready: {
    nl: "OK, IK BEN KLAAR",
    fr: "OK, JE SUIS PRÊT ",
    en: "OK, I'M READY ",
    de: "OK, ICH BIN BEREIT"
  },
  i_already_have_account: {
    nl: "Ik heb al een account",
    fr: "J'ai déjà un compte",
    en: "I already have an account",
    de: "Ich habe bereits ein Konto"
  },
  i_dont_have_account: {
    nl: "Ik heb nog geen account",
    fr: "Je n'ai pas de compte",
    en: "I don't have an account",
    de: "Ich habe noch kein Konto"
  },
  ci_create_an_account: {
    nl: "Maak een account aan",
    fr: "Créer un compte",
    en: "Create an account",
    de: "Ein Konto erstellen"
  },
  ci_create_account: {
    nl: "Account aanmaken",
    fr: "Créer un compte",
    en: "Create account",
    de: "Konto erstellen"
  },
  // 01 Welcome -----------------------------------------------------------------------------------------
  welcome_to_local: {
    nl: "Welkom bij 100% Lokaal",
    fr: "100% Local, soyez les bienvenus",
    en: "Welcome to 100% Local",
    de: "Willkommen bei 100% Lokal"
  },
  thank_you_for_participating: {
    nl: "Dank je... om mee te werken aan het beheren en optimaliseren van de gegevens van jouw onderneming!",
    fr: "Merci... de participer à la gestion et à l'optimisation des données de votre entreprise !",
    en: "Thank you... for participating in managing and optimizing your company's data!",
    de: "Vielen Dank... für Ihre Teilnahme an der Verwaltung und Optimierung der Daten Ihres Unternehmens!"
  },
  we_help_as_much: {
    nl: "Wij helpen je zoveel mogelijk!",
    fr: "Nous vous aidons au maximum !",
    en: "We help you as much as possible!",
    de: "Wir helfen Ihnen so viel wie möglich!"
  },
  this_additional_info: {
    nl: "Deze bijkomende informatie zal nuttig zijn voor elke bezoeker die jouw onderneming heeft gevonden.",
    fr: "Ces informations supplémentaires seront utiles à tout visiteur ayant trouvé votre entreprise.",
    en: "This additional information will be useful to any visitor who has found your business.",
    de: "Diese zusätzlichen Informationen werden für jeden Besucher nützlich sein, der Ihr Unternehmen gefunden hat."
  },
  my_company_active: {
    nl: "MIJN ONDERNEMING IS ACTIEF?",
    fr: "MON ENTREPRISE EST ACTIVE ?",
    en: "MY COMPANY IS ACTIVE?",
    de: "IST MEIN UNTERNEHMEN AKTIV?"
  },
  now_we_can_continue: {
    nl: "Nu kunnen we verder!",
    fr: "Maintenant, nous pouvons continuer !",
    en: "Now we can continue!",
    de: "Jetzt können wir weitermachen!"
  },
  your_company_deactivated: {
    nl: "Jouw onderneming wordt gedeactiveerd :)",
    fr: "Votre entreprise sera désactivée :)",
    en: "Your company will be deactivated :)",
    de: "Ihr Unternehmen wird deaktiviert :)"
  },
  i_accept_GDPR: {
    nl: "Ik aanvaard de verwerking van mijn gegevens volgens de GDPR/AVG.",
    fr: "J'accepte le traitement de mes données conformément au RGPD.",
    en: "I accept the processing of my data according to the GDPR.",
    de: "Ich akzeptiere die Verarbeitung meiner Daten gemäß der DSGVO."
  },
  last_accepted_on: {
    nl: "Laatst aanvaard op",
    fr: "Dernière acceptation le",
    en: "Last accepted on",
    de: "Zuletzt akzeptiert am"
  },
  i_accept_the: {
    nl: "Ik aanvaard de",
    fr: "J'accepte les",
    en: "I accept the",
    de: "Ich akzeptiere die"
  },
  general_terms_and_conditions: {
    nl: "algemene voorwaarden",
    fr: "conditions générales",
    en: "general terms and conditions",
    de: "Allgemeinen Geschäftsbedingungen"
  },
  i_accept_my_municipality: {
    nl: "Ik aanvaard dat mijn gegevens - in combinatie met 100procentlokaal - gedeeld worden met mijn stad of gemeente.",
    fr: "J'accepte que mes données - combinées avec 100pourcentlocal - soient partagées avec ma ville ou ma commune.",
    en: "I accept that my data - combined with 100percentlocal - will be shared with my city or municipality.",
    de: "Ich akzeptiere, dass meine Daten - kombiniert mit 100prozentlokal - mit meiner Stadt oder Gemeinde geteilt werden."
  },
  city_support_good_idea: {
    nl: "Vind je de ondersteuning van dit initiatief door jouw stad of gemeente een goed idee?",
    fr: "Pensez-vous que le soutien de votre ville ou municipalité à cette initiative est une bonne idée ?",
    en: "Do you think your city or municipality's support for this initiative is a good idea?",
    de: "Halten Sie die Unterstützung dieser Initiative durch Ihre Stadt oder Gemeinde für eine gute Idee?"
  },
  would_you_find_city_support_good_idea: {
    nl: "Zou jij de ondersteuning van dit initiatief door jouw stad of gemeente een goed idee vinden?",
    fr: "Considéreriez-vous que soutenir cette initiative par votre ville ou municipalité serait une bonne idée ?",
    en: "Would you consider supporting this initiative by your city or municipality a good idea?",
    de: "Würden Sie die Unterstützung dieser Initiative durch Ihre Stadt oder Gemeinde als eine gute Idee betrachten?"
  },
  please_choose_an_option: {
    nl: "Gelieve een optie te kiezen!",
    fr: "Veuillez choisir une option !",
    en: "Please choose an option!",
    de: "Bitte wählen Sie eine Option!"
  },
  yes_i_appreciate_support_city: {
    nl: "Ja! Ik waardeer de ondersteuning van dit initiatief door mijn stad of gemeente",
    fr: "Oui! J'apprécie le soutien de ma ville ou municipalité pour cette initiative",
    en: "Yes! I appreciate the support of my city or municipality for this initiative",
    de: "Ja! Ich schätze die Unterstützung meiner Stadt oder Gemeinde für diese Initiative"
  },
  yes_i_would_appreciate_support_city: {
    nl: "Ja! Ik zou de ondersteuning van dit initiatief door mijn stad of gemeente een schitterend idee vinden!",
    fr: "Oui ! J'aimerais le soutien de ma ville ou municipalité pour cette initiative!",
    en: "Yes! I would love the support of my city or municipality for this initiative!",
    de: "Ja! Ich würde die Unterstützung meiner Stadt oder Gemeinde für diese Initiative sehr schätzen!"
  },
  no_opinion_about_project: {
    nl: "Ik heb geen mening over dit project",
    fr: "Je n'ai pas d'avis sur ce projet",
    en: "I have no opinion about this project",
    de: "Ich habe keine Meinung zu diesem Projekt"
  },
  contest: {
    nl: "WEDSTRIJD!",
    fr: "CONCOURS !",
    en: "CONTEST!",
    de: "WETTBEWERB!"
  },
  you_are_participating_too_right: {
    nl: "Jij doet toch ook mee?",
    fr: "Participez-vous aussi ?",
    en: "You're participating too, right?",
    de: "Sie nehmen auch teil, oder?"
  },
  fantastic: {
    nl: "Fantastisch!",
    fr: "Fantastique !",
    en: "Fantastic!",
    de: "Fantastisch!"
  },
  you_do_not_know_what_missing: {
    nl: "Je weet niet wat je mist :)",
    fr: "Vous ne savez pas ce que vous manquez :)",
    en: "You do not know what you are missing :)",
    de: "Sie wissen nicht, was Ihnen entgeht :)"
  },
  for_the: {
    nl: "Voor de",
    fr: "Pour la",
    en: "For the",
    de: "Für die"
  },
  businesspage_100procentlocal: {
    nl: "Business Page in 100%Lokaal",
    fr: "Page Entreprise en 100% Local",
    en: "Business Page in 100%Local",
    de: "Geschäftsseite in 100%Lokal"
  },
  businesspage_100procentlocal_part_2: {
    nl: "betaalt de ondernemer € 100/jaar. Dit is het éénmalig voordeel dat je verkrijgt wanneer je alle gegevens voor jouw onderneming aanvult!",
    fr: "l'entrepreneur paie 100 €/an. C'est l'avantage unique que vous recevez lorsque vous remplissez toutes les données pour votre entreprise !",
    en: "the entrepreneur pays € 100/year. This is the one-time benefit that you receive when you complete all the data for your company!",
    de: "Der Unternehmer zahlt € 100/Jahr. Dies ist der einmalige Vorteil, den Sie erhalten, wenn Sie alle Daten für Ihr Unternehmen ausfüllen!"
  },
  businesspage_100procentlocal_part_3: {
    nl: "Bovendien doet iedere ondernemer die deelneemt ook automatisch mee met de grote wedstrijd. Elke 100ste ondernemer wint een jaarabonnement voor een compleet dienstenpakket ter waarde van € 1600.",
    fr: "De plus, chaque entrepreneur qui participe participe automatiquement au grand concours. Chaque 100e entrepreneur gagne un abonnement annuel pour un ensemble complet de services d'une valeur de 1600 €.",
    en: "In addition, every entrepreneur who participates automatically participates in the big competition. Every 100th entrepreneur wins an annual subscription for a complete service package worth € 1600.",
    de: "Darüber hinaus nimmt jeder Unternehmer, der teilnimmt, automatisch am großen Wettbewerb teil. Jeder 100. Unternehmer gewinnt ein Jahresabonnement für ein komplettes Dienstleistungspaket im Wert von 1600 €."
  },
  attention: {
    nl: "OPGELET!",
    fr: "ATTENTION !",
    en: "ATTENTION!",
    de: "ACHTUNG!"
  },
  businesspage_100procentlocal_part_4: {
    nl: "Het aanleveren van het logo (.ai, .eps, .svg, .pdf-vector) maakt deel uit van het wedstrijdreglement voor deelname.",
    fr: "La fourniture du logo (.ai, .eps, .svg, .pdf vector) fait partie du règlement du concours pour la participation.",
    en: "Supplying the logo (.ai, .eps, .svg, .pdf vector) is part of the competition rules for entry.",
    de: "Die Bereitstellung des Logos (.ai, .eps, .svg, .pdf-Vektor) ist Teil der Wettbewerbsregeln für die Teilnahme."
  },
  contest_rules: {
    nl: "Lees of haal hier het wedstrijdreglement op.",
    fr: "Lire ou télécharger le règlement du concours ici.",
    en: "Read or download the competition rules here.",
    de: "Lesen oder laden Sie hier die Wettbewerbsregeln herunter."
  },
  // 02 Personal -----------------------------------------------------------------------------------------
  start_personal_info: {
    nl: "Laten we starten met je persoonlijke gegevens",
    fr: "Commençons par vos informations personnelles",
    en: "Let's start with your personal information",
    de: "Lassen Sie uns mit Ihren persönlichen Daten beginnen"
  },
  the_information_below: {
    nl: "Onderstaande gegevens worden",
    fr: "Les informations ci-dessous ne sont",
    en: "The information below is",
    de: "Die unten stehenden Informationen werden"
  },
  never: {
    nl: "NOOIT",
    fr: "JAMAIS",
    en: "NEVER",
    de: "NIE"
  },
  the_information_below_part2: {
    nl: "online gepubliceerd maar ook niet gedeeld met uw lokaal bestuur.",
    fr: "publiées en ligne ni partagées avec votre gouvernement local.",
    en: "published online nor shared with your local government.",
    de: "werden online veröffentlicht, noch mit Ihrer örtlichen Regierung geteilt."
  },
  the_information_below_part3: {
    nl: "Deze zijn uitsluitend voor intern gebruik om je te contacteren wanneer er toch iets niet correct is ingevuld.",
    fr: "Ceux-ci sont à usage interne uniquement pour vous contacter si quelque chose n'est pas rempli correctement.",
    en: "These are for internal use only to contact you if something is not filled in correctly.",
    de: "Diese dienen ausschließlich zur internen Verwendung, um Sie zu kontaktieren, falls etwas nicht korrekt ausgefüllt ist."
  },
  ci_prename: {
    nl: "Voornaam",
    fr: "Prénom",
    en: "First name",
    de: "Vorname"
  },
  ci_name: {
    nl: "Naam",
    fr: "Nom",
    en: "Name",
    de: "Name"
  },
  ci_mobile: {
    nl: "Mobiele telefoon",
    fr: "Téléphone mobile",
    en: "Mobile phone",
    de: "Mobiltelefon"
  },
  ci_phone: {
    nl: "Telefoon",
    fr: "Téléphone",
    en: "Phone",
    de: "Telefon"
  },
  ci_mail: {
    nl: "Email",
    fr: "E-mail",
    en: "E-mail",
    de: "E-Mail"
  },
  ci_fax: {
    nl: "Fax",
    fr: "Télécopieur",
    en: "Fax",
    de: "Fax"
  },
  // 03 Search -----------------------------------------------------------------------------------------
  how_can_visitors_reacth_you: {
    nl: "Hoe kunnen bezoekers je bereiken?",
    fr: "Les visiteurs, comment peuvent-ils vous joindre ?",
    en: "How can visitors reach you?",
    de: "Wie können Besucher Sie erreichen?"
  },
  you_understand_importance: {
    nl: "Je begrijpt dat het heel belangrijk is om correcte gegevens van je onderneming te publiceren.",
    fr: "Vous comprenez qu'il est très important de publier des données correctes sur votre entreprise.",
    en: "You understand that it is very important to publish correct data about your company.",
    de: "Sie verstehen, dass es sehr wichtig ist, korrekte Daten über Ihr Unternehmen zu veröffentlichen."
  },
  visitors_reacht_you: {
    nl: "Op deze manier kunnen bezoekers je ook bereiken.",
    fr: "Ainsi, les visiteurs peuvent également vous joindre.",
    en: "This way visitors can also reach you.",
    de: "Auf diese Weise können Sie auch Besucher erreichen."
  },
  the_following_information: {
    nl: "De volgende informatie zal",
    fr: "Les informations suivantes",
    en: "The following information",
    de: "Die folgenden Informationen"
  },
  visible_to_everyone: {
    nl: "ZICHTBAAR ZIJN VOOR IEDEREEN!",
    fr: "SERONT VISIBLES PAR TOUS !",
    en: "WILL BE VISIBLE TO EVERYONE!",
    de: "WIRD FÜR JEDEN SICHTBAR SEIN!"
  },
  corporate_name: {
    nl: "Maatschappelijke Naam (kan niet gewijzigd worden)",
    fr: "Nom de l'entreprise (ne peut pas être modifié)",
    en: "Corporate name (cannot be changed)",
    de: "Firmenname (kann nicht geändert werden)"
  },
  commercial_name: {
    nl: "Commerciële naam",
    fr: "Nom commercial",
    en: "Commercial name",
    de: "Handelsname"
  },
  commercial_name_info: {
    nl: 'Indien uw "Commerciële naam" verschilt van uw "Officiële naam (ook Maatschappelijke naam genoemd)" kan je deze hier invoeren. Wij respecteren alle leestekens zoals je deze hier zelf invoert. Gebruik dus HOOFDLETTERS en kleine letters waar nodig!',
    fr: 'Si votre "Nom commercial" est différent de votre "Nom officiel (également appelé Raison sociale)", vous pouvez le saisir ici. Nous respectons tous les signes de ponctuation lorsque vous les saisissez ici vous-même. Utilisez donc des majuscules et des minuscules si nécessaire !',
    en: 'If your "Commercial name" is different from your "Official name (also called Corporate name)" you can enter it here. We respect all punctuation marks as you enter them here yourself. So use UPPER and lowercase where necessary!',
    de: 'Wenn Ihr "Handelsname" von Ihrem "Offiziellen Namen (auch Firmenname genannt)" abweicht, können Sie ihn hier eingeben. Wir respektieren alle Satzzeichen, die Sie hier selbst eingeben. Verwenden Sie also GROSS- und Kleinbuchstaben, wo nötig!'
  },
  email_never_visible: {
    nl: "Email (wordt dus nooit zichtbaar)",
    fr: "E-mail (ne sera donc jamais visible)",
    en: "E-mail (thus never becomes visible)",
    de: "E-Mail (wird also niemals sichtbar)"
  },
  publication_of_one_telephone: {
    nl: "De publicatie van 1 telefoonnummer is een",
    fr: "La publication d'1 numéro de téléphone est une",
    en: "The publication of 1 telephone number is a",
    de: "Die Veröffentlichung einer Telefonnummer ist eine"
  },
  requirement: {
    nl: "vereiste",
    fr: "exigence",
    en: "requirement",
    de: "Voraussetzung"
  },
  of_FPS_economy: {
    nl: "van FOD Economie",
    fr: "du SPF Economie",
    en: "of FPS Economy",
    de: "der FPS-Wirtschaft"
  },
  do_you_trade_companies_or_consumers: {
    nl: "Handel je met bedrijven of consumenten?",
    fr: "Commercez-vous avec des entreprises ou des consommateurs ?",
    en: "Do you trade with companies or consumers?",
    de: "Handeln Sie mit Unternehmen oder Verbrauchern?"
  },
  i_trade_with_b2b: {
    nl: "Ik handel met bedrijven (B2B)",
    fr: "Je commerce avec des entreprises (B2B)",
    en: "I trade with companies (B2B)",
    de: "Ich handle mit Unternehmen (B2B)"
  },
  i_trade_with_b2c: {
    nl: "Ik handel met consumenten (B2C)",
    fr: "Je commerce avec les consommateurs (B2C)",
    en: "I trade with consumers (B2C)",
    de: "Ich handle mit Verbrauchern (B2C)"
  },
  i_trade_with_both: {
    nl: "Ik handel met bedrijven (B2B) en consumenten (B2C)",
    fr: "Je commerce avec les entreprises (B2B) et les consommateurs (B2C)",
    en: "I trade with companies (B2B) and consumers (B2C)",
    de: "Ich handle mit Unternehmen (B2B) und Verbrauchern (B2C)"
  },
  what_do_you_offer: {
    nl: "Wat bied je aan?",
    fr: "Qu'offres-tu ?",
    en: "What do you offer?",
    de: "Was bieten Sie an?"
  },
  i_offer_both: {
    nl: "Goederen & Diensten",
    fr: "Biens et Services",
    en: "Goods and services",
    de: "Waren und Dienstleistungen"
  },
  i_offer_goods: {
    nl: "Goederen",
    fr: "Biens",
    en: "Goods",
    de: "Waren"
  },
  i_offer_services: {
    nl: "Diensten",
    fr: "Services",
    en: "Services",
    de: "Dienstleistungen"
  },
  you_company_is_now_found_on: {
    nl: "Jouw onderneming wordt nu gevonden op",
    fr: "Votre entreprise sera désormais présente sur",
    en: "Your company is now found on",
    de: "Ihr Unternehmen wird jetzt gefunden auf"
  },
  all_activities: {
    nl: "alle activiteiten",
    fr: "toutes les activités",
    en: "all activities",
    de: "alle Aktivitäten"
  },
  that_you_fill_in: {
    nl: "die je aanvult.",
    fr: "que vous réalisez.",
    en: "that you fill in",
    de: "die Sie ausfüllen"
  },
  you_company_is_now_found_on_your_page: {
    nl: "Jouw onderneming wordt nu gevonden op jouw pagina",
    fr: "Votre entreprise sera désormais présente sur votre page",
    en: "Your company is now found on your page",
    de: "Ihr Unternehmen wird jetzt auf Ihrer Seite gefunden"
  },
  public_your_reachability_info: {
    nl: "Publiceer je bereikbaarheid info!",
    fr: "Publiez vos informations de contact !",
    en: "Publish your reachability info!",
    de: "Veröffentlichen Sie Ihre Erreichbarkeitsinformationen!"
  },
  // 04 Activities -----------------------------------------------------------------------------------------
  what_is_your_main_activity: {
    nl: "Wat is jouw voornaamste activiteit?",
    fr: "Quelle est votre activité principale ?",
    en: "What is your main activity?",
    de: "Was ist Ihre Haupttätigkeit?"
  },
  we_searching_and_linking_to_CBE: {
    nl: "Wij zoeken en linken naar de KBO",
    fr: "Nous recherchons et mettons en lien avec la BCE",
    en: "We are searching and linking to the CBE",
    de: "Wir suchen und verlinken zum CBE"
  },
  will_not_be_visible: {
    nl: "Dit wordt niet zichtbaar",
    fr: "Ceci ne sera pas visible",
    en: "This will not be visible",
    de: "Dies wird nicht sichtbar sein"
  },
  what_is_your_first_main_activity: {
    nl: "Wat is jouw voornaamste activiteit (eerste)?",
    fr: "Quelle est votre activité principale (première) ?",
    en: "What is your main activity (first)?",
    de: "Was ist Ihre Haupttätigkeit (erste)?"
  },
  what_is_your_second_main_activity: {
    nl: "Wat is jouw voornaamste activiteit (tweede)?",
    fr: "Quelle est votre activité principale (seconde) ?",
    en: "What is your main activity (second)?",
    de: "Was ist Ihre Haupttätigkeit (zweite)?"
  },
  what_is_your_third_main_activity: {
    nl: "Wat is jouw voornaamste activiteit (derde)?",
    fr: "Quelle est votre activité principale (troisième) ?",
    en: "What is your main activity (third)?",
    de: "Was ist Ihre Haupttätigkeit (dritte)?"
  },
  tell_us_more: {
    nl: "Vertel ons meer",
    fr: "Dites-nous en plus",
    en: "Tell us more",
    de: "Erzählen Sie uns mehr"
  },
  tell_us_more_of_your_activities: {
    nl: "Vertel ons meer over je activiteiten",
    fr: "Dites-nous en plus sur vos activités",
    en: "Tell us more about your activities",
    de: "Erzählen Sie uns mehr über Ihre Aktivitäten"
  },
  what_else_do_you_do: {
    nl: "Wat doe je nog meer?",
    fr: "Que faites-vous d'autre ?",
    en: "What else do you do?",
    de: "Was tun Sie sonst noch?"
  },
  // 05 Opening hours -----------------------------------------------------------------------------------------
  publish_your_opening_hours: {
    nl: "Publiceer jouw openingsuren",
    fr: "Publiez vos heures d'ouverture",
    en: "Publish your opening hours",
    de: "Veröffentlichen Sie Ihre Öffnungszeiten"
  },
  make_sure_all_information_correct: {
    nl: "Maak dat al je gegevens correct zijn!",
    fr: "Assurez-vous que toutes vos informations sont correctes !",
    en: "Make sure all your information is correct!",
    de: "Stellen Sie sicher, dass alle Ihre Informationen korrekt sind!"
  },
  ci_regular_hours: {
    nl: "Reguliere openingstijden",
    fr: "Horaires d'ouverture réguliers",
    en: "Regular opening hours",
    de: "Reguläre Öffnungszeiten"
  },
  ci_opening_hours_special: {
    nl: "Speciale openingstijden",
    fr: "Horaires d'ouverture spéciaux",
    en: "Special opening hours",
    de: "Besondere Öffnungszeiten"
  },
  ci_add_opening_hours: {
    nl: "Openingsuren toevoegen",
    fr: "Ajouter des heures d'ouverture",
    en: "Add opening hours",
    de: "Öffnungszeiten hinzufügen"
  },
  // 06 Address -----------------------------------------------------------------------------------------
  where_can_we_find_you: {
    nl: "Waar kunnen we je vinden?",
    fr: "Où pouvons-nous vous trouver ?",
    en: "Where can we find you?",
    de: "Wo können wir Sie finden?"
  },
  is_your_address_correct: {
    nl: "Is jouw adres correct?",
    fr: "Votre adresse est-elle correcte ?",
    en: "Is your address correct?",
    de: "Ist Ihre Adresse korrekt?"
  },
  public_your_info: {
    nl: "Publiceer je informatie",
    fr: "Publiez vos informations",
    en: "Publish your info",
    de: "Veröffentlichen Sie Ihre Informationen"
  },
  ci_street: {
    nl: "Straat",
    fr: "Rue",
    en: "Street",
    de: "Straße"
  },
  ci_house_number: {
    nl: "Huisnummer",
    fr: "Numéro de maison",
    en: "House number",
    de: "Hausnummer"
  },
  ci_bus_number: {
    nl: "Bus nummer",
    fr: "Numéro de bus",
    en: "Bus number",
    de: "Busnummer"
  },
  ci_postal_code: {
    nl: "Postcode",
    fr: "Code postal",
    en: "Postal code",
    de: "Postleitzahl"
  },
  ci_city: {
    nl: "Stad",
    fr: "Ville",
    en: "City",
    de: "Stadt"
  },
  ci_province: {
    nl: "Provincie",
    fr: "Province",
    en: "Province",
    de: "Provinz"
  },
  ci_country: {
    nl: "Land",
    fr: "Pays",
    en: "Country",
    de: "Land"
  },
  // 07 Photos -----------------------------------------------------------------------------------------
  ci_welcome_photos: {
    nl: "Welkom bij de foto sectie! Voeg hier de foto's toe van jouw onderneming!",
    fr: "Bienvenue dans la section des photos ! Ajoutez ici les photos de votre entreprise !",
    en: "Welcome to the photos section! Add the photos of your company here!",
    de: "Willkommen im Fotobereich! Fügen Sie hier die Fotos Ihres Unternehmens hinzu!"
  },
  ci_upload_photos: {
    nl: "Uploaden foto's",
    fr: "Télécharger des photos",
    en: "Upload photos",
    de: "Fotos hochladen"
  },
  photo_has_to_be_in: {
    nl: "De foto moet in .jpg, .png of .gif-formaat zijn.",
    fr: "La photo doit être au format .jpg, .png ou .gif.",
    en: "The photo has to be in .jpg, .png or .gif format.",
    de: "Das Foto muss im .jpg-, .png- oder .gif-Format vorliegen."
  },
  add_good_photos: {
    nl: "Voeg goede foto's toe, zo breng je je onderneming helemaal in beeld!",
    fr: "Ajoutez de belles photos pour bien représenter votre entreprise !",
    en: "Add good photos, that will really represent your company!",
    de: "Fügen Sie gute Fotos hinzu, die Ihr Unternehmen wirklich repräsentieren!"
  },
  make_sure_no_people_visible: {
    nl: "Zorg ervoor dat er geen mensen op de foto's staan!",
    fr: "Assurez-vous qu'aucune personne n'est visible sur les photos !",
    en: "Make sure no people are visible in the photos!",
    de: "Stellen Sie sicher, dass keine Personen auf den Fotos zu sehen sind!"
  },
  we_dont_publish_photos: {
    nl: "Wij publiceren geen foto's waar mensen op staan",
    fr: "Nous ne publions pas de photos où des personnes sont visibles",
    en: "We don't publish photos where people are visible",
    de: "Wir veröffentlichen keine Fotos, auf denen Personen zu sehen sind"
  },
  make_sure_no_people_visible_part_2: {
    nl: "tenzij jij ons hiervoor expliciet toelating geeft en de personen op de foto geen bezwaren hebben.",
    fr: "à moins que vous ne nous donniez votre accord explicite et que les personnes sur la photo ne s'y opposent pas.",
    en: "unless you explicitly give us permission and the people in the photo have no objections.",
    de: "es sei denn, Sie geben uns ausdrücklich Ihre Erlaubnis und die Personen auf dem Foto haben keine Einwände."
  },
  the_photos_will_be_verified: {
    nl: "De foto's zullen door ons team gecontroleerd worden alvorens ze online geplaatst worden.",
    fr: "Les photos seront vérifiées par notre équipe avant d'être mises en ligne.",
    en: "The photos will be verified by our team before being posted online.",
    de: "Die Fotos werden von unserem Team überprüft, bevor sie online gestellt werden."
  },
  // 08 Logos -----------------------------------------------------------------------------------------
  public_your_logo: {
    nl: "Publiceer jouw logo",
    fr: "Publiez votre logo",
    en: "Publish your logo",
    de: "Veröffentlichen Sie Ihr Logo"
  },
  the_logo_has_to_be_in: {
    nl: "Het logo moet in .ai, .eps, .svg of .pdf-vector formaat zijn.",
    fr: "Le logo doit être au format .ai, .eps, .svg ou .pdf vector.",
    en: "The logo has to be in .ai, .eps, .svg or .pdf vector format.",
    de: "Das Logo muss im .ai-, .eps-, .svg- oder .pdf-Vektorformat vorliegen."
  },
  add_good_logo: {
    nl: "Voeg een goed logo toe, zodat jouw onderneming er staat!",
    fr: "Ajoutez un bon logo pour que votre entreprise se démarque !",
    en: "Add a good logo so your company stands out!",
    de: "Fügen Sie ein gutes Logo hinzu, damit Ihr Unternehmen hervorsticht!"
  },
  the_logo_will_be_verified: {
    nl: "Het logo zal door ons team gecontroleerd worden alvorens het online geplaatst wordt.",
    fr: "Le logo sera vérifié par notre équipe avant d'être mis en ligne.",
    en: "The logo will be verified by our team before being posted online.",
    de: "Das Logo wird von unserem Team überprüft, bevor es online gestellt wird."
  },
  // 09 Social -----------------------------------------------------------------------------------------
  the_website_will_be_linked: {
    nl: "De website wordt rechtstreeks gelinkt en is eenvoudig aan te passen in jouw portaal.",
    fr: "Le site Web sera directement lié et facile à modifier dans votre portail.",
    en: "The website will be directly linked and is easy to adjust in your portal.",
    de: "Die Website wird direkt verlinkt und lässt sich in Ihrem Portal einfach anpassen."
  },
  facebook: {
    nl: "Facebook",
    fr: "Facebook",
    en: "Facebook",
    de: "Facebook"
  },
  instagram: {
    nl: "Instagram",
    fr: "Instagram",
    en: "Instagram",
    de: "Instagram"
  },
  linkedin: {
    nl: "LinkedIn",
    fr: "LinkedIn",
    en: "LinkedIn",
    de: "LinkedIn"
  },
  ci_facebook: {
    nl: "Facebook link",
    fr: "Lien Facebook",
    en: "Facebook link",
    de: "Facebook-Link"
  },
  ci_instagram: {
    nl: "Instagram link",
    fr: "Lien Instagram",
    en: "Instagram link",
    de: "Instagram-Link"
  },
  ci_linkedin: {
    nl: "LinkedIn link",
    fr: "Lien LinkedIn",
    en: "LinkedIn link",
    de: "LinkedIn-Link"
  },
  add_your_social_media: {
    nl: "Voeg jouw social media kanalen toe",
    fr: "Ajoutez vos chaînes de médias sociaux",
    en: "Add your social media channels",
    de: "Fügen Sie Ihre Social-Media-Kanäle hinzu"
  },
  // 10 Delivery -----------------------------------------------------------------------------------------
  do_you_do_deliveries: {
    nl: "Doe jij leveringen?",
    fr: "Faites-vous des livraisons ?",
    en: "Do you do deliveries?",
    de: "Liefern Sie?"
  },
  no: {
    nl: "Nee",
    fr: "Non",
    en: "No",
    de: "Nein"
  },
  yes: {
    nl: "Ja",
    fr: "Oui",
    en: "Yes",
    de: "Ja"
  },
  i_accept: {
    nl: "Ik aanvaard",
    fr: "J'accepte",
    en: "I accept",
    de: "Ich akzeptiere"
  },
  i_reject: {
    nl: "Ik weiger",
    fr: "Je refuse",
    en: "I reject",
    de: "Ich lehne ab"
  },
  can_we_publish: {
    nl: "Mogen wij dat publiceren?",
    fr: "Pouvons-nous publier cela ?",
    en: "Can we publish that?",
    de: "Können wir das veröffentlichen?"
  },
  can_we_publish_your_deliveries: {
    nl: "Mogen wij jouw leveringen publiceren?",
    fr: "Pouvons-nous publier vos livraisons ?",
    en: "Can we publish your deliveries?",
    de: "Können wir Ihre Lieferungen veröffentlichen?"
  },
  can_we_publish_your_deliveries_part_2: {
    nl: "Let wel! Het publiceren van jouw leveringsinformatie genereert extra omzet voor jouw onderneming!",
    fr: "Attention ! La publication de vos informations de livraison génère des revenus supplémentaires pour votre entreprise !",
    en: "Please note! Publishing your delivery information generates additional revenue for your company!",
    de: "Bitte beachten Sie! Die Veröffentlichung Ihrer Lieferinformationen generiert zusätzliche Einnahmen für Ihr Unternehmen!"
  },
  ci_delivery: {
    nl: "Levering",
    fr: "Livraison",
    en: "Delivery",
    de: "Lieferung"
  },
  ci_pickup: {
    nl: "Afhalen",
    fr: "Ramasser",
    en: "Pickup",
    de: "Abholung"
  },
  ci_delivery_fee: {
    nl: "Leveringskost",
    fr: "Frais de livraison",
    en: "Delivery fee",
    de: "Liefergebühr"
  },
  // 11 Payment methods -----------------------------------------------------------------------------------------
  ci_payment_methods: {
    nl: "Betalingsmethodes",
    fr: "Méthodes de payement",
    en: "Payment methods",
    de: "Zahlungsmethoden"
  },
  ci_online_payment: {
    nl: "Online betaling",
    fr: "Paiement en ligne",
    en: "Online payment",
    de: "Online-Zahlung"
  },
  ci_online_payment_possible: {
    nl: "Online betaling mogelijk",
    fr: "Paiement en ligne possible",
    en: "Online payment possible",
    de: "Online-Zahlung möglich"
  },
  ci_cash: {
    nl: "Contant",
    fr: "Espèces",
    en: "Cash",
    de: "Bargeld"
  },
  ci_bancontact: {
    nl: "Bancontact",
    fr: "Bancontact",
    en: "Bancontact",
    de: "Bancontact"
  },
  ci_visa: {
    nl: "Visa",
    fr: "Visa",
    en: "Visa",
    de: "Visum"
  },
  ci_paypal: {
    nl: "PayPal",
    fr: "PayPal",
    en: "PayPal",
    de: "PayPal"
  },
  ci_credit_card: {
    nl: "Kredietkaart",
    fr: "Carte de crédit",
    en: "Credit card",
    de: "Kreditkarte"
  },
  ci_bank_transfer: {
    nl: "Bankoverschrijving",
    fr: "Virement bancaire",
    en: "Bank transfer",
    de: "Banküberweisung"
  },
  ci_apple_pay: {
    nl: "Apple Pay",
    fr: "Apple Pay",
    en: "Apple Pay",
    de: "Apple Pay"
  },
  ci_google_pay: {
    nl: "Google Pay",
    fr: "Google Pay",
    en: "Google Pay",
    de: "Google Pay"
  },
  ci_payconiq: {
    nl: "Payconiq",
    fr: "Payconiq",
    en: "Payconiq",
    de: "Payconiq"
  },
  ci_meal_voucher: {
    nl: "Maaltijdcheque",
    fr: "Chèque-repas",
    en: "Meal voucher",
    de: "Essensgutschein"
  },
  ci_ecocheque: {
    nl: "Ecocheque",
    fr: "Écocheque",
    en: "Ecocheque",
    de: "Ökocheck"
  },
  // 12 Products & services -----------------------------------------------------------------------------------------
  ci_add_product: {
    nl: "Product toevoegen",
    fr: "Ajouter un produit",
    en: "Add product",
    de: "Produkt hinzufügen"
  },
  ci_add_service: {
    nl: "Dienst toevoegen",
    fr: "Ajouter un service",
    en: "Add service",
    de: "Dienst hinzufügen"
  },
  ci_description_product: {
    nl: "Beschrijf jouw product",
    fr: "Décrivez votre produit",
    en: "Describe your product",
    de: "Beschreiben Sie Ihr Produkt"
  },
  ci_description_service: {
    nl: "Beschrijf jouw dienst",
    fr: "Décrivez votre service",
    en: "Describe your service",
    de: "Beschreiben Sie Ihren Dienst"
  },
  // 13 Photos -----------------------------------------------------------------------------------------
  ci_add_photo: {
    nl: "Foto toevoegen",
    fr: "Ajouter une photo",
    en: "Add photo",
    de: "Foto hinzufügen"
  },
  // 14 FAQ -----------------------------------------------------------------------------------------
  ci_faq: {
    nl: "FAQ",
    fr: "FAQ",
    en: "FAQ",
    de: "FAQ"
  },
  // 15 Contact info -----------------------------------------------------------------------------------------
  ci_contact_info: {
    nl: "Contact informatie",
    fr: "Informations de contact",
    en: "Contact info",
    de: "Kontaktinformation"
  },
  // 16 Email -----------------------------------------------------------------------------------------
  ci_email_invoice: {
    nl: "Factuur e-mail",
    fr: "E-mail de facturation",
    en: "Invoice e-mail",
    de: "Rechnungs-E-Mail"
  },
  ci_email_support: {
    nl: "Support e-mail",
    fr: "E-mail de support",
    en: "Support e-mail",
    de: "Support-E-Mail"
  },
  // 17 Website -----------------------------------------------------------------------------------------
  ci_website: {
    nl: "Website",
    fr: "Site web",
    en: "Website",
    de: "Webseite"
  },
  // 18 Save -----------------------------------------------------------------------------------------
  ci_save: {
    nl: "Opslaan",
    fr: "Sauvegarder",
    en: "Save",
    de: "Speichern"
  },
  ci_save_your_work: {
    nl: "Bewaar jouw werk",
    fr: "Sauvegardez votre travail",
    en: "Save your work",
    de: "Speichern Sie Ihre Arbeit"
  }
};
var _default = CustomerInfo;
exports["default"] = _default;